'use client';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import { ReactNode, MouseEvent } from 'react';

interface HeaderMenuItemProps {
  children: ReactNode;
  href?: string;
  active?: boolean;
  fontSize?: string;
  fontFamily?: string;
  fontWeight?: string;
  textColor?: string;
  className?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
}

const HeaderMenuItem = ({
  children,
  href = '#',
  active = false,
  fontSize = 'text-sm',
  fontFamily = 'Inter',
  fontWeight = 'font-medium',
  textColor = 'text-text-secondary',
  className,
  onClick,
}: HeaderMenuItemProps) => {
  const baseClasses = twMerge(
    'transition-colors duration-200 hover:text-primary-background focus:outline-none focus:text-primary-background',
    fontSize,
    fontWeight,
    textColor,
    className
  );

  const fontFamilyClass = fontFamily === 'Instrument Sans' ? 'font-instrument' : 'font-inter';

  const handleClick = (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
    }
  };

  if (href && href !== '#') {
    return (
      <Link data-component-id="src/components/ui/HeaderMenuItem.tsx:47:6" data-component-path="src/components/ui/HeaderMenuItem.tsx" data-component-line="47" data-component-end-line="54" data-component-file="HeaderMenuItem.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%5Bvar%3Ahref%5D%22%7D"
        href={href}
        className={twMerge(baseClasses, fontFamilyClass)}
        onClick={handleClick}
        role="menuitem"
      >
        {children}
      </Link>
    );
  }

  return (
    <button data-component-id="src/components/ui/HeaderMenuItem.tsx:59:4" data-component-path="src/components/ui/HeaderMenuItem.tsx" data-component-line="59" data-component-end-line="65" data-component-file="HeaderMenuItem.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
      className={twMerge(baseClasses, fontFamilyClass)}
      onClick={handleClick}
      role="menuitem"
    >
      {children}
    </button>
  );
};

export default HeaderMenuItem;